export default __webpack_public_path__ + "static/media/e767753b22b4b842.562932b07ea43542033e7b4ebca7279f.svg";